// extracted by mini-css-extract-plugin
module.exports = {"contentBlockTitle":"contentBlockTitle___2QpHk","title":"title___2cIEZ"};